import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import PlusIcon from '@ncl/assets/images/PlusIcon';
import MinusIcon from '@ncl/assets/images/MinusIcon';
import { ItemWrapper, Title, Header } from './AccordionItem.styles';

const AccordionItem = ({ title, content, width }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <ItemWrapper onClick={() => setIsOpen(!isOpen)}>
      <Header>
        <Title style={width ? { maxWidth: width } : null}>{title}</Title>
        {isOpen ? <MinusIcon /> : <PlusIcon />}
      </Header>
      <AnimatePresence>
        {isOpen ? (
          <motion.div
            key="release"
            exit={{ height: 0, opacity: 0 }}
            animate={{ height: 'auto', opacity: 1 }}
            initial={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.2, type: 'tween' }}
          >
            {content}
          </motion.div>
        ) : null}
      </AnimatePresence>
    </ItemWrapper>
  );
};

export default AccordionItem;
